import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const MonitorIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{ viewBox: '0 0 24 24' }}
      {...props}
    >
      <g clipPath="url(#clip0_11751_290027)">
        <path
          d="M20 18C21.105 18 21.99 17.105 21.99 16L22 6C22 4.895 21.105 4 20 4H4C2.895 4 2 4.895 2 6V16C2 17.105 2.895 18 4 18H1C0.447715 18 0 18.4477 0 19C0 19.5523 0.447715 20 1 20H23C23.5523 20 24 19.5523 24 19C24 18.4477 23.5523 18 23 18H20ZM4 6H20V16H4V6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11751_290027">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

export default React.memo(MonitorIcon);
